webpackJsonp([266548939047157],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logo = __webpack_require__(40);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'head' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement('img', { src: logo, alt: 'DAN EV - Dienst am N\xE4chsten', className: 'logo' }),
	        _react2.default.createElement(
	          'span',
	          {
	            id: 'global-slogan',
	            'data-editable': 'simpletext',
	            className: 'slogan',
	            'data-global': 'data-global'
	          },
	          'Nachbarschaftshilfe',
	          _react2.default.createElement('br', null),
	          'von Mensch zu Mensch'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hotline' },
	          _react2.default.createElement(
	            'strong',
	            {
	              id: 'global-fragen',
	              'data-editable': 'simpletext',
	              'data-global': 'data-global'
	            },
	            'Sie haben Fragen?'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            {
	              id: 'global-phone',
	              'data-editable': 'simpletext',
	              'data-global': 'data-global'
	            },
	            '0174/3444893',
	            _react2.default.createElement('br', null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'nav' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/home' },
	              'Startseite'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/geschichte' },
	              '\xDCber Uns'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/dienstleistungen' },
	              'Dienstleistungen'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/sie-wollen-helfen' },
	              'Sie wollen helfen?'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'active' },
	            _react2.default.createElement(
	              'a',
	              { href: '/mitglieder', className: 'active' },
	              'Mitglieder'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/kontakt' },
	              'Kontakt'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          { id: 'mitglieder', 'data-editable': 'simpletext', className: 'mb1' },
	          'Sie wollen Mitglied werden?'
	        ),
	        _react2.default.createElement(
	          'p',
	          { id: 'content', 'data-editable': 'text' },
	          'Mit der Mitgliedschaft unterst\xFCtzen Sie unseren gemeinn\xFCtzigen Verein.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'Wenn Sie Mitglied werden m\xF6chten, nehmen Sie gerne Kontakt auf unter:',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:info@dan-ev.de' },
	            'info@dan-ev.de'
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mitglieder-js-df2f9e398b4968cf10e4.js